export default {
  data() {
    return {
      localizedTags: [
        {
          key: 'Before Breakfast',
          value: 'message.tagBeforeBreakfast'
        },
        {
          key: 'After Breakfast',
          value: 'message.tagAfterBreakfast'
        },
        {
          key: 'Before Lunch',
          value: 'message.tagBeforeLunch'
        },
        {
          key: 'After Lunch',
          value: 'message.tagAfterLunch'
        },
        {
          key: 'Before Dinner/meal',
          value: "message.tagBeforeDinnerMeal"
        },
        {
          key: 'After Dinner/meal',
          value: 'message.tagAfterDinnerMeal'
        },
        {
          key: 'Party',
          value: 'message.tagParty'
        },
        {
          key: 'Shop',
          value: 'message.tagShop'
        },
        {
          key: 'Snack',
          value: 'message.tagSnack'
        },
        {
          key: 'Menstruation',
          value: 'message.tagMenstruation'
        },
        {
          key: 'Drink',
          value: 'message.tagDrink'
        },
        {
          key: 'Fasting',
          value: 'message.tagFasting'
        },
        {
          key: 'Activity',
          value: 'message.tagActivity'
        },
        {
          key: 'Work',
          value: 'message.tagWork'
        },
        {
          key: 'Correction',
          value: 'message.tagCorrection'
        },
        {
          key: 'Driving',
          value: 'message.tagDriving'
        }
      ]

    }
  },
  methods: {
    localizeTag(key) {
      let self = this;
      return self.localizedTags.filter(function (item) {
        return item.key === key;
      })[0].value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Localization/BgTags/TagLocalizerMixin.js